export default __webpack_public_path__ + "static/media/a01.134ef7bf.jpg";